import React, {Component, ReactNode} from 'react';
import {Collapse, Container, Nav, Navbar, PopoverBody, Popover} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import {Spin as Hamburger} from 'hamburger-react';
import {connect} from 'react-redux';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import Property from '@episerver/spa-core/Components/Property';
import Link from '@episerver/spa-core/Components/Link';
import GetSize from 'app/Components/Shared/GetSize/GetSize';
import CmsHomePageData from 'app/Models/Content/CmsHomePageData';
import HeaderSearchDesktop from 'app/Components/Shared/HeaderSearch/HeaderSearchDesktop.js';
import ProviderManager from '../../../provider/providerManager.js';
import {BooleanProperty} from '@episerver/spa-core/Property';
import Config from '../../../Config';
import './Header.scss';

interface HeaderProps {
  startPage: CmsHomePageData;
  context: IEpiserverContext;
  path: string;
  isBusinessNavigation: BooleanProperty;
  userDetails: any;
  currentPath: string;
  isOtpAuthenticated: any;
  isFullAuthenticated: any;
  transactionData: any;
}

interface HeaderState {
  isOpen: boolean;
  isOpenCollapse: boolean;
  btn_class: string;
  openHeaderSearchDesktop: boolean;
  height: number;
  searchResultMobile: SearchResult[];
  showPopUp: boolean;
  closePopLogin: boolean;
  inputText: string;
  isPopoverOpen: boolean;
  isPopoverMobileOpen: boolean;
}

interface SearchResult {
  id: number;
  title: string;
  url: string;
}

class Header extends Component<HeaderProps, HeaderState> {
  public constructor(props: HeaderProps) {
    super(props);
    this.state = this.getInitialState();
  }

  protected getInitialState(): HeaderState {
    return {
      isOpen: false,
      isOpenCollapse: false,
      btn_class: '',
      openHeaderSearchDesktop: false,
      height: 100,
      searchResultMobile: [],
      showPopUp: false,
      closePopLogin: true,
      inputText: '',
      isPopoverOpen: false,
      isPopoverMobileOpen: false,
    };
  }
  closeMenu() {
    if (isMobile) {
      this.setState({inputText: ''});
      this.setState({searchResultMobile: []});
      this.setState({isOpenCollapse: false});
    }
  }

  clickToJoin() {
    if (this.props.isBusinessNavigation.value) {
      this.props.context.navigateTo(this.props.startPage.joinNavigationLinkBusiness.value.url);
    } else {
      this.props.context.navigateTo(this.props.startPage.joinNavigationLinkPrivate.value.url);
    }
    this.closeMenu();
  }

  goToPersonalArea() {
    this.closeMenu();
    this.setState({isPopoverOpen: false});
    this.setState({isPopoverMobileOpen: false});
    if (this.props.isBusinessNavigation.value) {
      this.props.context.navigateTo(this.props.startPage.businessSelfcareNavigationLink.value.url);
    } else {
      this.props.context.navigateTo(this.props.startPage.personalNavigationLink.value.url);
    }
  }

  openbHeader() {
    this.props.context.navigateTo(this.props.startPage.bussinessNavigationLink.value.url);
  }

  closebHeader() {
    this.props.context.navigateTo(this.props.startPage.privateNavigationLink.value.url);
  }

  getD() {
    this.setState({height: GetSize()});
  }
  checkMenu() {
    if (isMobile) {
      if (this.state.isOpen) {
        this.setState({isOpenCollapse: false});
        this.setState({inputText: ''});
        this.setState({searchResultMobile: []});
      } else {
        this.setState({isOpen: true});
        this.setState({isOpenCollapse: true});
      }
    }
  }

  openM() {
    this.setState({showPopUp: true});
  }
  closeM() {
    this.setState({showPopUp: false});
  }
  closePopLogin() {
    this.setState({closePopLogin: true});
  }
  onCollapseEntering() {
    this.setState({isOpenCollapse: true});
  }
  onCollapseExited() {
    this.setState({isOpenCollapse: false});
    this.setState({isOpen: false});
  }

  async changeHandlerSearch(input) {
    this.setState({inputText: input.value});
    if (this.state.inputText.length >= 3) {
      try {
        const result = await ProviderManager.getProviderData('headerSearch', [input.value, 0, 10]);
        this.setState({searchResultMobile: result.Body.items});
      } catch (error) {}
    }
  }

  clickSearchResult(url) {
    if (isMobile) {
      this.setState({isOpenCollapse: false});
      this.setState({inputText: ''});
      this.setState({searchResultMobile: []});
      window.location.assign(url);
    }
  }

  customersSlection() {
    if (isMobile) {
      return null;
    } else if (!isMobile) {
      if (this.props.isBusinessNavigation.value === true) {
        return (
          <div onClick={this.closebHeader.bind(this)} className='header-container__link-plain font-weight-bold'>
            סלקום פרטי
          </div>
        );
      } else if (this.props.isBusinessNavigation.value === false) {
        return (
          <div onClick={this.openbHeader.bind(this)} className='header-container__link-plain business-link font-weight-bold'>
            סלקום עסקים
          </div>
        );
      }
    }
  }
  customersSlectionMobile() {
    if (this.props.isBusinessNavigation.value === true) {
      return (
        <div onClick={this.closebHeader.bind(this)} className='header-container__link-plain '>
          סלקום פרטי
        </div>
      );
    } else {
      return (
        <div onClick={this.openbHeader.bind(this)} className='header-container__link-plain business-link '>
          סלקום עסקים
        </div>
      );
    }
  }

  getHighlightedText(text) {
    // Split on highlight term and include term into parts, ignore case
    const parts = text.split(new RegExp(`(${this.state.inputText})`, 'gi'));
    // const customersSlection =  isMobile ? isBusiness :

    return (
      <span>
        {' '}
        {parts.map((part, i) => (
          <span key={i} style={part.toLowerCase() === this.state.inputText.toLowerCase() ? {color: 'white'} : {}}>
            {part}
          </span>
        ))}{' '}
      </span>
    );
  }
  openHeaderSearchDesktop() {
    this.setState({openHeaderSearchDesktop: true});
  }

  closeHeaderSearchDesktop() {
    this.setState({openHeaderSearchDesktop: false});
  }

  togglePopover() {
    this.setState({isPopoverOpen: !this.state.isPopoverOpen});
  }

  togglePopoverMobile() {
    this.setState({isPopoverMobileOpen: !this.state.isPopoverMobileOpen});
  }

  public render(): ReactNode | null {
    let $this = this;
    let homePageUrl =
      this.props.isBusinessNavigation.value == true
        ? this.props.startPage.bussinessNavigationLink.value.url
        : this.props.startPage.privateNavigationLink.value.url;
    let isBusiness = this.props.isBusinessNavigation.value === true;
    let displayName =
      this.props.isFullAuthenticated == true
        ? this.props.userDetails.firstName
        : this.props.isOtpAuthenticated == true
        ? this.props.userDetails.contactNumber
        : 'איזור אישי';
    return;
    <>
      <header key='MoseyHeader' className='header-container__navbar-container'>
        <Container
          style={{height: this.state.isOpen ? GetSize() : ''}}
          className={this.state.isOpen ? 'dark-mobile-container' : 'navbar-container'}>
          <div className='row no-gutter pt-3'>
            <div className='col-xl-1 col-lg-1 col-md-2 container-logo d-sm-none d-none d-lg-block container-navbar'>
              <a href={homePageUrl} className='cellcom-logo'>
                {this.props.transactionData?.generalDetails?.family === 'W'
                  ? <Property iContent={this.props.startPage} field='siteLogoCellcomEnergy' context={this.props.context} />
                  : <Property iContent={this.props.startPage} field='siteLogo' context={this.props.context} />
                }
              </a>
            </div>
            <div className='col-xl-7 col-lg-6 col-md-1 col-sm-1 col-1 px-0 mx-0 container-navbar'>
              <Navbar light color='black' className='sticky-top navbar navbar-expand-lg pr-1'>
                {isMobile ? (
                  <Hamburger
                    color={this.state.isOpen ? '#ffffff' : '#000000'}
                    size={20}
                    toggled={this.state.isOpen}
                    toggle={this.checkMenu.bind(this)}
                    onToggle={this.getD.bind(this)}
                    direction='left'
                  />
                ) : (
                  ''
                )}
                {this.state.isOpen ? (
                  <div className='col-lg-none col-xl-none header-search-mobile'>
                    <input
                      onChange={(e) => this.changeHandlerSearch(e.target)}
                      name='search'
                      type='search'
                      placeholder='חיפוש בסלקום'
                      className='col-lg-none col-xl-none search-input'
                      aria-label='Search through site content'
                      autoComplete='off'
                    />
                    {this.state.inputText.length >= 3 && this.state.searchResultMobile ? (
                      <div className='header-search-result-mobile'>
                        <ul>
                          {this.state.searchResultMobile.length > 0 ? (
                            this.state.searchResultMobile.map(function (item, i) {
                              const text = $this.getHighlightedText(item.title);
                              return (
                                <li key={item.id}>
                                  <a href={'#'} onClick={$this.clickSearchResult.bind($this, item.url)} className='result-item'>
                                    {text}
                                  </a>
                                </li>
                              );
                            })
                          ) : (
                            <li>לא נמצאו תוצאות</li>
                          )}
                        </ul>
                      </div>
                    ) : null}
                  </div>
                ) : (
                  ''
                )}

                <Collapse
                  navbar
                  isOpen={this.state.isOpenCollapse}
                  onClick={this.closeMenu.bind(this)}
                  onEntering={this.onCollapseEntering.bind(this)}
                  onExited={this.onCollapseExited.bind(this)}>
                  {!isBusiness ? (
                    <Nav navbar>
                      <ContentArea context={this.props.context} data={this.props.startPage.mainMenu} noWrap={true} />
                    </Nav>
                  ) : (
                    <Nav navbar>
                      <ContentArea context={this.props.context} data={this.props.startPage.mainBusinessMenu} noWrap={true} />
                    </Nav>
                  )}
                </Collapse>
                {this.state.isOpen && (
                  <div className='header-site-switch-mobile d-sm-block d-block d-lg-none'>
                    <div className='p-2 d-flex'>{this.customersSlectionMobile()}</div>
                  </div>
                )}
              </Navbar>
            </div>
            <div className='col-sm-5 col-5 container-logo d-lg-none container-logo-m  pr-3'>
              <a href={homePageUrl} className='cellcom-logo'>
                <Property
                  iContent={this.props.startPage}
                  field={this.state.isOpen ? 'siteLogoMobileWhite' : 'siteLogoMobile'}
                  context={this.props.context}
                />
              </a>
            </div>

            <div className=''>
              <div className='pt-2 header-site-switch__text d-flex'>{this.customersSlection()}</div>
            </div>
            <div className='col-xl-3 col-lg-3 col-md-6 col-sm-6 col-6 d-flex header-left-container'>
              <div className='header-join-container d-flex'>
                <div className='header-join d-flex' onClick={this.clickToJoin.bind(this)}>
                  <Link href={''} className='header-container__link-plain-join'>
                    <span className='header-join-text'>להצטרפות</span>
                  </Link>
                </div>
              </div>
              {/* desktop - check if login */}
              <div className='header-personal-container d-block'>
                {this.props.userDetails && this.props.userDetails.firstName != '' && this.props.userDetails.firstName != undefined ? (
                  <div className='header-personal-area' id='PopoverLegacy' onClick={this.togglePopover.bind(this)}>
                    <div className='header-personal-text'>{displayName}</div>
                    {/* <div className='header-personal-text-name'> איזור אישי</div> */}
                    <Popover trigger='legacy' placement='bottom' target='PopoverLegacy' isOpen={this.state.isPopoverOpen}>
                      {/* Desktop - logged in    */}
                      <PopoverBody>
                        <div className='login-container'>
                          <div className='login-container__pink-text' onClick={this.goToPersonalArea.bind(this)}>
                            <Link href={''} className='login-container__pink-text pink-text'>
                              מעבר לאיזור האישי
                            </Link>
                          </div>
                          <div className='login-container__pink-text'>
                            <a className='login-container__pink-text' href={Config.logoutPage}>
                              התנתקות
                            </a>
                          </div>
                        </div>
                      </PopoverBody>
                    </Popover>
                  </div>
                ) : (
                  <Link
                    href={
                      isBusiness
                        ? this.props.startPage.businessSelfcareNavigationLink.value
                        : this.props.startPage.personalNavigationLink.value
                    }
                    className='header-personal-area'>
                    {/* Desktop - before login    */}
                    <div className='header-personal'>
                      <div className='header-container__link-plain-join'>
                        <div className='header-personal-text-space'> איזור אישי</div>
                        <div className='header-personal-text'></div>
                      </div>
                    </div>
                  </Link>
                )}
              </div>

              <div>
                <div className='d-none d-md-block header-search__img' onClick={this.openHeaderSearchDesktop.bind(this)}>
                  {' '}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </header>
      {this.state.openHeaderSearchDesktop ? (
        <HeaderSearchDesktop
          closeHeader={this.closeHeaderSearchDesktop.bind(this)}
          field='siteLogo'
          siteCellcomEnergyLogoField='siteLogoCellcomEnergy'
          iContent={this.props.startPage}
          context={this.props.context}></HeaderSearchDesktop>
      ) : null}
    </>;
  }
}

const mapStateToProps = (state) => ({
  userDetails: state.authentication.loginData.userDetails,
  currentPath: state.ViewContext.currentPath,
  isOtpAuthenticated: state.authentication.loginData.isOtpAuthenticated,
  isFullAuthenticated: state.authentication.loginData.isFullAuthenticated,
  transactionData: state.cellcomTransactionSummary.transactionData,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
